import React, { useState } from "react";
import { Button, Flex, Spin, Checkbox } from "antd";
import { instance } from "utils/axios";
import { useParams } from "react-router-dom";

export default function Qpay() {
  const getBase64Img = (item) => {
    return `data:image/pngs;base64,${item}`;
  };

  const [data, setData] = useState(null);
  const [qpData, setQpayData] = useState(null);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [chLoading, setChLoading] = useState(false);
  const [approve, setApprove] = useState(false);
  const [status, setStatus] = useState(null);
  let { guid } = useParams();
  const checkPayment = () => {
    setChLoading(true);
    instance({
      method: "get",
      url: `/admissions/feecheck/${guid}`,
    })
      .then((res) => {
        if (res.data.status == "Success") {
          setText("Төлөгдсөн байна.");
          fetchData();
        } else {
          setText("Төлөгдөөгүй байна.");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setChLoading(false));
  };
   const fetchData = () => {
     setApprove(true);
     setLoading(true);
     instance({
       method: "get",
       url: `/admissions/applicant/${guid}`,
     })
       .then((res) => {
        if(res.data.status!="Success"){
           
          let json = JSON.parse(res.data.qpayData);
        
          setQpayData(json);
        }
          setStatus(res.data.status);
           setData(res.data);
       })
       .catch((err) => {
         console.log(err);
       })
       .finally(() => setLoading(false));
   };
  return loading ? (
    <div className="flex flex-col items-center mt-20">
      <Flex align="center" gap="middle">
        <Spin size="large" />
      </Flex>
    </div>
  ) : !approve ? (
    <div className="relative flex flex-col items-center h-screen font-raleway">
      <div className="mt-20  text-[16pt] md:text-[20pt] xl:text-[30pt] font-bold text-primary leading-[1.38] font-raleway">
        Өргөдлийн хураамж
      </div>
      <div className="flex flex-col justify-center w-full max-w-2xl p-6 mt-10 border-2 border-primary rounded-lg bg-white shadow-md">
        <p className=" text-gray-800 leading-relaxed">
          Томүжин Алтернатив сургуульд өргөдөл илгээх хураамж нь{" "}
          <strong>60,000 төгрөг</strong> байх ба энэхүү журамтай танилцаж,
          хүлээн зөвшөөрснөөр интернэт банкаар төлбөр төлөх цонх руу очно.
        </p>
        <ul className="list-disc pl-5 mt-4 ml-5 text-gray-800">
          <li className="mb-5">
            Энэхүү хураамжийг өргөдөл илгээхийн өмнө бүрэн төлөх шаардлагатай
            бөгөөд нэгэнт хийгдсэн тохиолдолд буцаан олгогдохгүй.
          </li>
          <li className="mb-5">
            Хураамж төлсөн нь сургуулийн элсэлтийн баталгаа болохгүй бөгөөд бүх
            өргөдлийг сургуулийн элсэлтийн бодлогын дагуу нягтлан шалгаж, хариуг
            гаргана.
          </li>
          <li className="mb-5">
            Төлбөр төлсний дараа таны бүртгэл баталгаажиж, 1-р шатны өргөдөл
            илгээх холбоос таны портал дээр харагдана.
          </li>
        </ul>
        <p className=" text-gray-800">
          Нэмэлт мэдээлэл авахыг хүсвэл
          <a
            href="mailto:admissions@tomujin.edu.mn"
            className="text-primary font-semibold"
          >
            {" "}
            admissions@tomujin.edu.mn
          </a>{" "}
          хаягаар холбогдоно уу.
        </p>
      </div>

      <div className="flex justify-center w-full pb-10 mt-10">
        <Checkbox
          value={approve}
          onChange={(e) => setApprove(e.target.checked)}
          onClick={fetchData}
        />
        <div className="ml-10">
          Би дээрх суудал бүртгэлийн хураамжийн нөхцлийг уншиж танилцсан,
          зөвшөөрч байна.
        </div>
      </div>
    </div>
  ) : (
    <div className="grid justify-center h-full grid-cols-12 gap-2 font-raleway  text-center">
      <div className="col-span-12  p-4  flex  justify-center text-[20pt] md:text-[20pt] font-bold  text-primary leading-[1.38]">
        Өргөдлийн хураамж төлөх.
      </div>
      {status == "Success" ? (
        <>
          {" "}
          <div className="col-span-3"></div>
          <div className="col-span-6 p-6 rounded-lg shadow  bg-slate-100 text-center justify-center ">
            <div className="justify-center w-full text-center mb-5">
              Таны өргөдлийн хураамж амжилттай төлөгдөж Томүжин Алтернатив
              сургуулийн элсэлтийн портал руу нэвтрэх эрх нээгдлээ.
              <br />
              портал руу нэвтэрнэ өргөдөл эхлүүлэх боломжтой.
              <br /> <br />
              {"Нэвтрэх нэр:  "} [таны имэйл хаяг]
              <br />
              {"Нууц үг:  "} [таны утасны дугаар]
            </div>
            <Button
              type="primary"
              onClick={() => {
                window.open("https://portal.tomujin.edu.mn", "_blank");
              }}
            >
              Портал руу нэвтрэх
            </Button>
          </div>
        </>
      ) : (
        // <div className="col-span-12 mt-16 p-4  flex  justify-center text-[20pt] md:text-[20pt]   text-primary leading-[1.38]">
        //   <p className="mt-4 text-lg md:text-xl text-gray-700">
        //     Таны төлбөр төлөгдсөн байна Томүжин Алтернатив сургуулийн элсэлтийн
        //     портал руу нэвтрэх, өргөдөл эхлүүлэх боломжтой болно.
        //   </p>
        //   <div>
        //     <Button

        //       type="primary"
        //       onClick={() => {
        //         window.open("https://portal.tomujin.edu.mn", "_blank");
        //       }}
        //     >
        //       Портал руу нэвтрэх
        //     </Button>
        //   </div>
        // </div>
        <>
          <div className="col-span-12 p-4 rounded-lg shadow md:col-start-4 md:col-span-3 h-70 bg-slate-100">
            <div className="p-2 italic font-bold text-center border-primary">
              Та интернэт банкаа ашиглан төлнө үү. Та төлбөрөө төлснөөр бүртгэл
              баталгаажих болно.
            </div>
            <div className="p-2 italic font-bold border-primary">Нэр:</div>
            <div className="p-2 italic border-primary">{data?.firstName}</div>
            <div className="p-2 italic font-bold border-primary">
              Регистрийн дугаар:
            </div>
            <div className="p-2 italic border-primary">{data.regno}</div>
            <div className="p-2 italic font-bold text-right border-t-2 border-primary">
              Төлөх дүн: ₮{Number(data.amount).toLocaleString()}
            </div>
          </div>

          <div className="col-span-12 p-4 rounded-lg shadow md:col-span-4 bg-slate-100">
            <div className="flex-wrap justify-center w-full md:flex">
              <div className="justify-center w-full mt-2 md:flex ">
                <img
                  src={getBase64Img(qpData?.qr_image)}
                  className="w-full md:w-3/5 "
                ></img>
              </div>
              <div className="justify-center w-full mt-2 md:flex ">{text}</div>

              {chLoading ? (
                <>
                  {" "}
                  <Spin size="small" />
                </>
              ) : (
                <Button
                  type="primary"
                  className="w-full mt-2 md:w-40"
                  onClick={() => {
                    checkPayment();
                  }}
                >
                  Гүйлгээ шалгах
                </Button>
              )}
              <div className="mt-4 md:hidden text-[16pt] flex justify-center  font-bold text-primary leading-[1.38]">
                Банкны аппликейшн
              </div>
              <div className="flex justify-center w-full mt-8 md:hidden ">
                <div className="grid grid-cols-12 gap-2">
                  {qpData?.urls.map((e, i) => {
                    return (
                      <div
                        w="100%"
                        key={i}
                        onClick={() => {
                          window.open(e.link);
                        }}
                        p={2}
                        className="flex items-center col-span-4 gap-6 p-4 rounded-lg shadow md:col-span-2"
                      >
                        <img
                          borderradius="full"
                          w="50px"
                          h="50px"
                          alt="avatar"
                          src={e.logo}
                          style={{ height: 50 }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
